import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { videoInstance } from "../instance";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { nowVassDetailState } from "../../stores/vass/nowVassDetailState";
import { focusCCTVUrlState } from "../../stores/vass/focusCCTVUrlState";

// TODO 영상추적 데이터 조회 API
export const useGetVideoList = (setVideoList) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const nowVassDetail = useRecoilValue(nowVassDetailState); // 현재 운송장 번호
  const setFocusCCTVUrl = useSetRecoilState(focusCCTVUrlState); // 표시될 CCTV 화면

  // NOTE 시작시간, 종료시간
  const startTime = dayjs(nowVassDetail?.scan_total_time)
    .subtract(5, "seconds")
    .format("YYYYMMDDHHmmss");
  const endTime = dayjs(nowVassDetail?.scan_total_time)
    .add(10, "minutes")
    .format("YYYYMMDDHHmmss");

  // TODO API 정보
  return useMutation(
    "getVideoList",
    () =>
      videoInstance.post("/getRecordVideoList", {
        sa_id: login.saId,
        account_id: login.accountId,
        ip: login.localIP,
        start_time: startTime,
        end_time: endTime,
      }),
    {
      // 성공 시
      onSuccess: (data) => {
        if (data.result === "00") {
          const sortedCamList = data.cam_list.sort((a, b) => a.cam_seq - b.cam_seq);
          setVideoList(sortedCamList);
          setFocusCCTVUrl(sortedCamList[0].stream_url);
          Swal.fire({
            icon: "success",
            title: "영상 조회 완료",
            text: "해당 운송장에 대한 영상을 성공적으로 조회하였습니다!",
            confirmButtonText: "확인",
          });
        } else if (data.result === "11") {
          Swal.fire({
            icon: "warning",
            title: "해당 지점은 영상 조회가 불가능합니다.",
            confirmButtonText: "확인",
          });
        }
      },

      // 실패 시
      onError: (error) => {
        console.log(error);
      },
    },
  );
};
